import React, { Component } from 'react';
import { Banner } from '../../Components'
import './Pricing.scss'
import { Link } from 'react-router-dom'
import WOW from 'wowjs'
import {Helmet} from "react-helmet"

/* eslint-disable */


import { observable } from 'mobx';
import { observer, inject } from 'mobx-react'


@inject('store')
@observer
class Pricing extends Component {

	componentDidMount() {
		new WOW.WOW({
			mobile: false,
		}).init();
		window.scrollTo(0, 0)
	}

	handlePurchase = (val) => {
		if (val === "Paper") {
			this.props.store.purchase.bookQuantity = 1
			this.props.store.purchase.onlineQuantity = 0
			this.props.store.purchase.combineQuantity = 0
			this.props.store.purchase.psychQuantity = 0
		}
		if (val === "Online") {
			this.props.store.purchase.bookQuantity = 0
			this.props.store.purchase.onlineQuantity = 1
			this.props.store.purchase.combineQuantity = 0
			this.props.store.purchase.psychQuantity = 0
		}
		if (val === "Combine") {
			this.props.store.purchase.bookQuantity = 0
			this.props.store.purchase.onlineQuantity = 0
			this.props.store.purchase.combineQuantity = 1
		}
		if (val === "Psych") {
			this.props.store.purchase.bookQuantity = 0
			this.props.store.purchase.onlineQuantity = 0
			this.props.store.purchase.psychQuantity = 1
		}
	}

	render() {

		const discount = this.props.store.purchase.organisation === "General Practice" ? true : false

		return (
			<div>
				<Helmet>
					<title>Pricing | GPbook</title>
				</Helmet>	
				<Banner title="Pricing" subtitle="Our Pricing Structure" />
				<div className="pricing-page">
					<FeaturePrices
						purchase={this.props.store.purchase}
						onDiscount={this.onDiscount}
						discount={discount}
						handlePurchase={this.handlePurchase} />	
					
					<PricingTables handlePurchase={this.handlePurchase} />
				</div>
			</div>
		);
	}
}


const FeaturePrices = ({ discount, onDiscount, handlePurchase, purchase }) =>
	<div className="feature-prices">
		<div className="page container text-center" style={{paddingTop:0, paddingBottom:0}}>
			<h2>Select a Plan</h2>

			<h4><u>Please choose</u> the organisation type that best describes you.</h4>

			<div className="select-option" style={{marginTop:15}}>
				<div className="btn-group" role="group" >
					
					<button type="button" onClick={() => purchase.organisation = "General Practice"} className={`btn ${purchase.organisation === "General Practice" || "white"}`}><i className="fa fa-user-md"></i>General Practice</button>

					<button type="button" onClick={() => purchase.organisation = "Specialist"} className={`btn ${purchase.organisation === "Specialist" || "white"}`}><i className="fa fa-male"></i> Specialist</button>

					<button type="button" onClick={() => purchase.organisation = "Other"} className={`btn ${purchase.organisation === "Other" || "white"}`}><i className="fa fa-building"></i>Other</button>

				</div>
			</div>
		</div>

		{!purchase.organisation ? <div style={{height:120}}></div> : null} 

		{purchase.organisation ? <FeaturePriceOptions purchase={purchase}
						onDiscount={onDiscount}
						discount={discount}
						handlePurchase={handlePurchase} /> : null}
	</div>




class FeaturePriceOptions extends Component {

	componentDidMount() {
		new WOW.WOW({
			mobile: false,
		}).init();
		window.scrollTo(0, 0)
	}

	render() {
		const { discount, onDiscount, handlePurchase, purchase} = this.props
		return (
			<div className="container">
			<div className="row no-gutters">
				<div className="col-md-4 ">
					<div
						className="option grey wow fadeInRight"
						data-wow-delay="0.75s">

						<div className="save">
							{/* <div>{`${new Date().getFullYear()}`}</div> */}
							<div>2024</div>
						</div> 
							
						<img src={require('./mssd.png')} alt="GPbook Logo" />
						<h3>Paper <span>Edition</span></h3>
						Medical & Surgical Specialist Referral Directory
                        <ul>
							{/* <li>{`${new Date().getFullYear()}`} Paper Edition</li> */}
							<li>2024 Paper Edition</li>
							<li>Specialist Directory</li>
							<li>Volume discounts available</li>
						</ul>
						<div className="price">
							<div className="number">
								{discount ? 66 : 92}
							</div>
							<div className="info">
								<b> per copy</b> <br />
								(includes delivery)
                            </div>
						</div>
						<Link to="/purchase" className="btn base" onClick={() => handlePurchase('Paper')}>Purchase</Link>
					</div>
				</div>
				<div className="col-md-4">
					<div className="option prime wow zoomIn">

						<div className="free">
                            <div>First</div>
                            <small>Month Free</small>
						</div> 
						
						<img src={require('./gpbook-logo.svg')} alt="GPbook Logo" width="64" />
						<h3>Online <span>Directory</span></h3>
						<b>GPbook.com.au</b>
						<ul>
							<li>New Online System</li>
							<li>Always up to date</li>
							<li>Lightning fast results</li>
							<li>Search by location</li>
						</ul>
						<div className="price">
							<div className="number">
								{discount ? <div>48<small></small></div> : "72"}
							</div>
							<div className="info">
								<b> per year for a user or room</b><br />(e.g. if you have 3 clinic rooms<br />then purchase 3 licences)<br />
								{/* (${discount ? "2.80" : "5"} per additional user) */}
                            </div>
						</div>
						<Link to="/purchase" className="btn" onClick={() => handlePurchase('Online')}>Purchase</Link>
					</div>
				</div>
				<div className="col-md-4">
					<div
						className="option orange wow fadeInLeft"
						data-wow-delay="0.75s">

						{/* <div className="save">
							<div>Old</div>
						</div> */}

						<img src={require('./mhprd.png')} alt="Psychology Edition" />
						<h3>Psychology <span>Edition</span></h3>
						<span>Mental Health and Psychology Referral Directory</span>
						<ul>
							<li>2020 Edition</li>
							<li>Telehealth details</li>
							<li><Link to="/contact">Request free online access (click here)</Link></li>
						</ul>
						<div className="price">
							{/* <div className="number">
								<div>NA<small></small></div>
							</div> */}
							<div className="info">
								{/* <b>One free copy per clinic</b> */}
								<b>Currently Unavailable</b>
								<br />
								<br />Thank you to all those who applied. Future possibility of the publication of this book will be based on finding new funding options.
								<br />
								<br />Mental health professionals are still able to apply for a listing online which is shown within the web version.
								<br />
								<br />
								</div>
						</div>
						{/* <Link to="/purchase" className="btn psych" onClick={() => handlePurchase('Psych')}>Purchase</Link> */}
					</div>
				</div>
			</div>
			<h4 className="text-center m-t-1">*All GP Practices and GPs receive a discounted price</h4>
		</div>
		);
	}
}




const PricingTables = ({ handlePurchase }) =>
	<div className="prices">
		{/* <OnlineTable handlePurchase={handlePurchase} /> */}
		{/* <BookAndOnline handlePurchase={handlePurchase} /> */}
		{/* <BookTable handlePurchase={handlePurchase} /> */}
	</div>


const OnlineTable = ({ handlePurchase }) =>
	<div className="bg-online">
		<div className="container">
			<div className="row">

				<div className="col-md-8">
					<h3 >Online Subscription</h3>
					<p>Our online subscriptions are available to GPs, specialists and other organisations or individuals who
may need to find a specialist. GPs receive a special discounted rate for access to the directory. When
you are signing up for a group practice, pay only for the number of rooms you wish to have
access in.</p>
					<table>
						<thead>
							<tr>
								<th></th>
								<th>GP User</th>
								<th>Non GP User</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td className="secondary" colSpan="3">
									All online subscriptions come with 1 month of complimentary access.
                                </td>
							</tr>
							<tr>
								<th>Single User</th>
								<td>$3.80 <span>/month</span></td>
								<td>$6.00 <span>/month</span></td>
							</tr>
							<tr>
								<th>Additional Users</th>
								<td>$2.80 <span>/month each</span></td>
								<td>$5.00 <span>/month each</span></td>
							</tr>

						</tbody>
					</table>
					<div className="option">
						<Link to="/purchase" className="btn" onClick={() => handlePurchase('Online')}>Purchase</Link> 
					</div>
				</div>
				<div className="col-md-4">
					<img src={require('../Home/screenshot-fast.jpg')} alt="Screenshot GPbook" width="100%" style={{ marginTop: 12, marginBottom: 32 }} />
				</div>

			</div>
		</div>
	</div>

const BookAndOnline = ({ handlePurchase }) =>
	<div className="bg-book-and-online">
		<div className="container">
			<div className="row">
				<div className="col-md-8">

					<h3 className="secondary">Book and Online Subscription <small className="text-base"><u>(Save 10%)</u></small></h3>
					<p>You can purchase both the book and the online directory in combination for a discounted price. To receive this discount you must purchase 12 months in advance.</p>

					<table>
						<thead>
							<tr>
								<th></th>
								<th>GP Users</th>
								<th>Non GP Users</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td className="secondary" colSpan="3"><b>10% discount</b> for the online and physical book. Includes Free delivery.</td>
							</tr>
							<tr>
								<th>Book + Online <br />(12 months)</th>
								<td>
									$90.54 <br/><span className="text-secondary">(includes 10% off)</span>
								</td>
								<td>
									$144 <br/><span className="text-secondary">(includes 10% off)</span>
								</td>
							</tr>
							<tr>

							</tr>
						</tbody>
					</table>

					<div className="option">
						<Link to="/purchase" className="btn secondary" onClick={() => handlePurchase('Combine')}>Purchase</Link>
					</div>
				</div>
				<div className="col-md-4">
					<img src={require('./combine.jpg')} alt="Screenshot GPbook" width="100%" style={{ marginTop: 32, marginBottom: 32 }} />
				</div>
			</div>
		</div>
	</div>

const BookTable = ({ handlePurchase }) =>
	<div className="bg-book">

		<div className="container">
			<div className="row">
				<div className="col-md-8">
					<h3 className="book">Book Only</h3>
					<p>The Medical & Surgical Specialist Referral Directory by Stephen Hodby is available for purchase. </p>

					<table>
						<thead>
							<tr>
								<th></th>
								<th>GP Users</th>
								<th>Non GP Users</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td className="secondary" colSpan="3"><b>Free Delivery.</b> All prices include postage and delivery costs.</td>
							</tr>
							<tr>
								<th>1 - 4 copies</th>
								<td>$66 <span>each</span></td>
								<td>$92 <span>each</span></td>
							</tr>
							<tr>
								<th>5+ copies</th>
								<td>$60 <span>each</span></td>
								<td>$86 <span>each</span></td>
							</tr>
							{/* <tr>
								<th>20+ copies</th>
								<td>$60 <span>each</span></td>
								<td>$86 <span>each</span></td>
							</tr> */}
							<tr>

							</tr>
						</tbody>
					</table>

					<div className="option">
						<Link to="/purchase" className="btn base" onClick={() => handlePurchase('Paper')}>Purchase</Link>
					</div>
				</div>
				<div className="col-md-3">
					<img src={require('../Home/mssd.svg')} alt="MSSD" width="90%" style={{ marginTop: 32, marginBottom: 32 }} />
				</div>
			</div>
		</div>
	</div>

export default Pricing;


// WEBPACK FOOTER //
// ./src/Containers/Pricing/Pricing.js